export class RfqDeadlineTimeError extends Error {
  constructor(
    public readonly code:
      "RFQ_DEADLINE_AMBIGUOUS_TIME" | "RFQ_DEADLINE_NONEXISTENT_TIME",
    message: string,
  ) {
    super(message);
  }
}

export function localDateTimeToUtc(localValue: string, timeZone: string) {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(localValue);
  if (!match) throw new Error("Geçerli bir teklif son tarihi seçin.");
  const desired = match.slice(1).map(Number);
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  });
  const partsAt = (timestamp: number) => {
    const parts = Object.fromEntries(
      formatter
        .formatToParts(new Date(timestamp))
        .filter((part) => part.type !== "literal")
        .map((part) => [part.type, Number(part.value)]),
    );
    return [parts.year, parts.month, parts.day, parts.hour, parts.minute];
  };
  const wallClock = Date.UTC(
    desired[0],
    desired[1] - 1,
    desired[2],
    desired[3],
    desired[4],
  );
  let candidate = wallClock;
  for (let attempt = 0; attempt < 3; attempt += 1) {
    const actual = partsAt(candidate);
    const represented = Date.UTC(
      actual[0],
      actual[1] - 1,
      actual[2],
      actual[3],
      actual[4],
    );
    candidate += wallClock - represented;
  }
  if (partsAt(candidate).some((part, index) => part !== desired[index]))
    throw new RfqDeadlineTimeError(
      "RFQ_DEADLINE_NONEXISTENT_TIME",
      "Seçilen yerel saat bu saat diliminde mevcut değil. Yaz saati geçişini kontrol edin.",
    );
  const matchingInstants = new Set<number>();
  for (let minutes = -180; minutes <= 180; minutes += 15) {
    const alternative = candidate + minutes * 60_000;
    if (partsAt(alternative).every((part, index) => part === desired[index]))
      matchingInstants.add(alternative);
  }
  if (matchingInstants.size > 1)
    throw new RfqDeadlineTimeError(
      "RFQ_DEADLINE_AMBIGUOUS_TIME",
      "Seçilen yerel saat yaz saati geçişinde iki farklı ana karşılık geliyor. Lütfen farklı bir saat seçin.",
    );
  return new Date(candidate).toISOString();
}
